import { SNK } from '@/helpers/helpers'

const historyCalls = {
  async api_history_shortcut(
    { commit, dispatch, rootGetters },
    { shortcut_id, label_id, namespace, resetReports = false },
  ) {
    dispatch('globals_action', 'disable_history_watcher')

    const qq = rootGetters[SNK('router_query', namespace)]
    const params = {
      gametype: qq.gametype,
      depth: qq.depth,
      stacks: qq.stacks,
      shortcut_id,
      label_id,
    }

    const storeAction = SNK('gamestate_set_api_history_shortcut', namespace)
    const res = await dispatch('api_call', {
      endpoint: 'poker/history/',
      mutation: 'api_poker_history',
      action: storeAction,
      actionArgs: { namespace },
      mutationArgs: { namespace },
      params,
    })

    if (resetReports) {
      commit('api_reset', { key: 'api_poker_reports' })
    }

    setTimeout(() => {
      dispatch('globals_action', 'enable_history_watcher', { root: true })
    })
    return res
  },
  async api_poker_history(
    { commit, dispatch, getters },
    {
      namespace,
      prevGmf = false,
      storeAction = null,
      enable_hsWatcher = false,
      cussol_id = null,
      query = {},
      routerParams = {
        push: false,
        replace: true,
        saveLocally: true,
      },
    },
  ) {
    const l_namespace = namespace ? `${namespace}/` : ''
    const qq = getters[`${l_namespace}router_query`]
    const solElite = getters[`${l_namespace}sol_elite`]
    const custom_solution_id = solElite?.want_use && cussol_id

    // console.log(solElite, cussol_id)
    // console.log(solElite, namespace)
    // debugger

    let params = {}
    let prevParams = {}

    const previous_actions = [
      qq.preflop_actions,
      qq.flop_actions,
      qq.turn_actions,
      qq.river_actions,
    ]
      .filter(i => i)
      .join('-')

    if (custom_solution_id) {
      // custom ai solutions
      const actionsParams = {
        preflop_actions: qq.preflop_actions,
        flop_actions: qq.flop_actions,
        turn_actions: qq.turn_actions,
        river_actions: qq.river_actions,
      }
      params = {
        custom_solution_id,
        ...actionsParams,
      }

      if (params.preflop_actions && !solElite.is_preflop) {
        params.preflop_actions = ''
        params.flop_actions = ''
        params.turn_actions = ''
        params.river_actions = ''

        console.error(`custom-sol-error-preflop-actions-present_history`)
      }
    } else {
      // gwiz solutions
      if (prevGmf && previous_actions) {
        prevParams = {
          previous_gametype: prevGmf.gametype,
          previous_depth: prevGmf.depth,
          previous_stacks: prevGmf.stacks,
          ...(previous_actions ? { previous_actions } : {}),
        }
        // console.log(prevParams)
      }

      let actionsParams = {}
      if (!prevGmf || !previous_actions) {
        actionsParams = {
          preflop_actions: qq.preflop_actions,
          flop_actions: qq.flop_actions,
          turn_actions: qq.turn_actions,
          river_actions: qq.river_actions,
        }
      }

      const boardParams = qq.board ? { board: qq.board } : {}
      params = {
        gametype: qq.gametype,
        depth: qq.depth,
        stacks: qq.stacks,
        ...actionsParams,
        ...prevParams,
        ...boardParams,
      }
    }

    if (getters.api_get('api_poker_next_actions').loading) {
      dispatch('api_set_call_status_by_idpart', {
        idPartsItems: [{ idPart: 'poker/next-actions', status: 'cacheAndDiss' }],
      })
      commit('api_reset', { key: 'api_poker_next_actions' })
      // console.log('stop next-actions request')
    }

    storeAction = storeAction || `${l_namespace}gamestate_set_api_history`
    const callId = `poker/history/${new URLSearchParams(params)}`

    await dispatch('api_call', {
      endpoint: 'poker/history/',
      mutation: 'api_poker_history',
      action: storeAction,
      actionArgs: {
        namespace, //
        params,
        routerParams,
        query,
      },
      mutationArgs: { namespace },
      params,

      hasCancel: false,
      dissIfSameCallInProgress: true,
      cacheCancelIdPart: 'poker/history',
      callId,
    })

    if (enable_hsWatcher) {
      setTimeout(() => {
        dispatch('globals_action', 'enable_history_watcher', { root: true })
      })
    }
  },
  async api_poker_next_actions(
    { commit, dispatch, getters },
    {
      namespace,
      cussol_id = null,
      enable_hsWatcher = false,
      routerParams = {
        push: false,
        replace: true,
        saveLocally: true,
      },
    },
  ) {
    const l_namespace = namespace ? `${namespace}/` : ''
    const qq = getters[`${l_namespace}router_query`]
    const solElite = getters[`${l_namespace}sol_elite`]
    const custom_solution_id = solElite?.want_use ? cussol_id || solElite.custom_solution_id : null

    let params = {}
    if (custom_solution_id) {
      // custom ai solutions
      const actionsParams = {
        preflop_actions: qq.preflop_actions,
        flop_actions: qq.flop_actions,
        turn_actions: qq.turn_actions,
        river_actions: qq.river_actions,
      }
      params = {
        custom_solution_id,
        ...actionsParams,
      }
      if (!solElite.is_preflop && params.preflop_actions) {
        // we must reset this ehen people insert preflop actions into url
        params.preflop_actions = ''
        params.flop_actions = ''
        params.turn_actions = ''
        params.river_actions = ''
        console.error(`custom-sol-error-preflop-actions-present_next-actions`)
      }
    } else {
      params = {
        gametype: qq.gametype,
        depth: qq.depth,
        stacks: qq.stacks,
        preflop_actions: qq.preflop_actions,
        flop_actions: qq.flop_actions,
        turn_actions: qq.turn_actions,
        river_actions: qq.river_actions,
      }
    }

    const boardParams = qq.board ? { board: qq.board } : {}
    params = {
      ...params,
      ...boardParams,
    }

    const storeAction = `${l_namespace}gamestate_set_next_actions`
    const callId = `poker/next-actions/${new URLSearchParams(params)}`

    await dispatch('api_call', {
      endpoint: 'poker/next-actions/',
      mutation: 'api_poker_next_actions',
      action: storeAction,
      actionArgs: { namespace, routerParams },
      mutationArgs: { namespace },
      params,

      hasCancel: false,
      dissIfSameCallInProgress: true,
      cacheCancelIdPart: 'poker/next-actions',
      callId,
    })

    if (enable_hsWatcher) {
      setTimeout(() => {
        dispatch('globals_action', 'enable_history_watcher', { root: true })
      })
    }
  },
}

export default historyCalls
